<template>
  <!-- 第三方发货 -->
  <div class="third_goods-box">
    <el-dialog
      :visible.sync="thirdPartyVisible"
      :close-on-click-modal="false"
      title="第三方商品"
      width="930px"
      center
      @close="closeDialog"
    >
      <!-- header头部 -->
      <header></header>

      <!-- body内容 -->
      <div class="body-box">
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleClick"
        >
          <el-tab-pane label="MDS物品" name="MDS">
            <MDSGoods
              v-model="orderInfo"
              @close="closeDialog"
              @refresh="$emit('refresh')"
              @callbackInfo="
                (val) => {
                  $emit('callbackInfo', val);
                }
              "
            ></MDSGoods>
          </el-tab-pane>

          <!-- <el-tab-pane label="IG物品" name="IG">
            <IgGoods
              v-model="orderInfo"
              @close="closeDialog"
              @refresh="$emit('refresh')"
              @callbackInfo="
                (val) => {
                  $emit('callbackInfo', val);
                }
              "
            ></IgGoods>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import MDSGoods from './deliverytype/MDSGoods'
import IgGoods from './deliverytype/IgGoods'

export default {
  name: 'third_goods',
  components: {
    MDSGoods,
    IgGoods
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: undefined
    },
    sourceType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      activeName: 'MDS', //默认展示第一个标题页面
      loading: false, //加载动画
      query: {

      },
    }
  },
  computed: {
    thirdPartyVisible: {
      //弹窗显示标志
      get() {
        return this.visible
      },
      set() { }
    },
    orderInfo: {
      // 订单信息
      get() {
        return this.value
      },
      set() { }
    },
    thirdPartyType: {
      //第三方类型
      get() {
        return this.sourceType
      },
      set(bool) {
      }
    }
  },
  watch: {
    thirdPartyType(val) {
      //根据传来的第三方类型，选择展示那个第三方
      switch (val) {
        case 1:
          this.activeName = "MDS"
          break;
        case 2:
          this.activeName = "IG"
          break;
        default:
          this.activeName = "MDS"
          break;
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    handleClick(val) {
      //切换卡片
    },
    getData() {
    },
    closeDialog() {
      //关闭第三方发货弹窗
      this.$emit('close');
    },
  },
}

</script>

<style lang="less" scoped>
.third_goods-box {
  //去掉此弹窗的内边距
  & /deep/ .el-dialog__body {
    padding: 0px;
  }

  header {
  }

  .body-box {
    max-height: 600px;
    overflow: auto;
  }
}
</style>
